var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullseyeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19056_10414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54688 4.7793C6.55664 4.85156 6.5625 4.92578 6.5625 5C6.5625 5.86328 5.86328 6.5625 5 6.5625C4.13672 6.5625 3.4375 5.86328 3.4375 5C3.4375 4.13672 4.13672 3.4375 5 3.4375C5.07422 3.4375 5.14844 3.44336 5.2207 3.45312L5.83008 2.84375L5.73633 2.28516C5.50195 2.2207 5.25391 2.1875 5 2.1875C3.44727 2.1875 2.1875 3.44727 2.1875 5C2.1875 6.55273 3.44727 7.8125 5 7.8125C6.55273 7.8125 7.8125 6.55273 7.8125 5C7.8125 4.74414 7.7793 4.49805 7.71484 4.26367L7.15625 4.16992L6.54688 4.7793ZM8.69727 4.37305C8.73242 4.57617 8.75 4.78516 8.75 5C8.75 7.07031 7.07031 8.75 5 8.75C2.92969 8.75 1.25 7.07031 1.25 5C1.25 2.92969 2.92969 1.25 5 1.25C5.21289 1.25 5.42188 1.26758 5.62695 1.30273L5.80859 1.12109L6.65039 0.279297C6.13281 0.0976562 5.57812 0 5 0C2.23828 0 0 2.23828 0 5C0 7.76172 2.23828 10 5 10C7.76172 10 10 7.76172 10 5C10 4.42188 9.90234 3.86719 9.7207 3.34961L8.87891 4.19141L8.69727 4.37305ZM7.13086 3.53125L8.12109 3.69531C8.32031 3.72852 8.52344 3.66406 8.66602 3.52148L9.66602 2.52148C9.82422 2.36328 9.76953 2.09375 9.56055 2.00977L8.4375 1.5625L7.98828 0.439453C7.9043 0.230469 7.63672 0.175781 7.47656 0.333984L6.47656 1.33594C6.33398 1.47852 6.26953 1.68164 6.30273 1.88086L6.4668 2.87109L4.66797 4.66797C4.48438 4.85156 4.48438 5.14844 4.66797 5.33008C4.85156 5.51172 5.14844 5.51367 5.33008 5.33008L7.12891 3.53125H7.13086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19056_10414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseyeArrow);
export default __webpack_public_path__ + "static/media/bullseye-arrow.182bd7a13a726d9e091c2e01869bf75a.svg";
export { ForwardRef as ReactComponent };